namespace Nobox.Administration {


    import fld = IntegrationRow.Fields;
    @Serenity.Decorators.registerEditor('Nobox.Administration.TenantIntegrationEditor')
    export class TenantIntegrationEditor extends NoboxEntityGrid<IntegrationRow,any> {
        protected getColumnsKey() { return IntegrationColumns.columnsKey; }
        protected getDialogType() { return IntegrationDialog; }
        protected getIdProperty() { return IntegrationRow.idProperty; }
        protected getInsertPermission() { return IntegrationRow.insertPermission; }
        protected getLocalTextPrefix() { return IntegrationRow.localTextPrefix; }
        protected getService() { return IntegrationService.baseUrl; }

        private pendingChanges: Q.Dictionary<any> = {};
        public callbackSave: () => void;

        constructor(container: JQuery) {
            super(container);
            this.getGridField().find(".grid-title").html("");
        }
    }
}